import * as MuiFormControlLabel from '@mui/material/FormControlLabel'
import React from 'react'

export type FormControlLabelProps = MuiFormControlLabel.FormControlLabelProps

export function FormControlLabel({ ...props }: FormControlLabelProps) {
  return <MuiFormControlLabel.default {...props} />
}
